import type { Agent } from '../api/types/entities/agent/types';

export function getAgentName(agent: Agent): string {
  if (agent.is_legal_entity) {
    return agent.group || 'Entité légale sans nom';
  }
  
  const firstName = agent.first_name || '';
  const lastName = agent.last_name || '';
  
  if (!firstName && !lastName) {
    return 'Agent sans nom';
  }
  
  return `${firstName} ${lastName}`.trim();
}

export function getAgentDisplayName(agent: Agent): string {
  const name = getAgentName(agent);
  const affiliation = agent.affiliation ? ` (${agent.affiliation})` : '';
  return `${name}${affiliation}`;
} 